import { ICurrencyView } from '@ClientModels/CurrencyView';
import { IExpenseModel } from '@Shared/models';

export const ADD_EXPENSES = 'ADD_EXPENSES';
export const UPDATE_EXPENSE = 'UPDATE_EXPENSE';
export const SET_CURRENCY_VIEW = 'SET_CURRENCY_VIEW';

export class AddExpenses {
  readonly type = ADD_EXPENSES;
  constructor(public expenses: IExpenseModel[]) {}
}

export class UpdateExpense {
  readonly type = UPDATE_EXPENSE;
  constructor(public expense: IExpenseModel) {}
}

export class SetCurrencyView {
  readonly type = SET_CURRENCY_VIEW;
  constructor(public currencyView: ICurrencyView) {}
}

export type ExpenseListAction = AddExpenses | UpdateExpense | SetCurrencyView;
